import { render, staticRenderFns } from "./masivos.vue?vue&type=template&id=bf28eacc"
import script from "./masivos.vue?vue&type=script&lang=ts"
export * from "./masivos.vue?vue&type=script&lang=ts"
import style0 from "./masivos.vue?vue&type=style&index=0&id=bf28eacc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports